export default function handleAgentName(firstName, lastName, alias) {
    const hasFirstName = firstName && firstName.trim() !== "";
    const hasLastName = lastName && lastName.trim() !== "";
    if (!hasFirstName && !hasLastName) {
        return alias;
    }
    else if (!hasFirstName) {
        return lastName;
    }
    else if (!hasLastName) {
        return firstName;
    }
    return `${lastName} ${firstName}`.trim();
};
